export const ESTIMATED_MS_PER_USER = 150;
export const MIN_USERS_FOR_ESTIMATE = 10;

export const formatTimeEstimate = (userCount: number): string | null => {
    if (userCount < MIN_USERS_FOR_ESTIMATE) return null;
    const totalMs = userCount * ESTIMATED_MS_PER_USER;
    const totalSeconds = Math.ceil(totalMs / 1000);
    if (totalSeconds < 60) return `~${totalSeconds} seconds`;
    const minutes = totalSeconds / 60;
    if (minutes < 10) return `~${minutes.toFixed(1).replace(/\.0$/, '')} minutes`;
    return `~${Math.round(minutes)} minutes`;
};
